// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".ActionToolbar__wrapper--3ZuxT {\n    margin: 20px 0;\n}\n\n.ActionToolbar__wrapper-with-divider--1yYv6 {\n    padding: 30px 0;\n    border-bottom: 1px solid #DDD;\n    margin-bottom: 30px;\n}", "",{"version":3,"sources":["ActionToolbar.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;AACvB","file":"ActionToolbar.css","sourcesContent":[".wrapper {\n    margin: 20px 0;\n}\n\n.wrapper-with-divider {\n    padding: 30px 0;\n    border-bottom: 1px solid #DDD;\n    margin-bottom: 30px;\n}"]}]);
// Exports
exports.locals = {
	"wrapper": "ActionToolbar__wrapper--3ZuxT",
	"wrapper-with-divider": "ActionToolbar__wrapper-with-divider--1yYv6",
	"wrapperWithDivider": "ActionToolbar__wrapper-with-divider--1yYv6"
};
module.exports = exports;
